import { Group, Title } from '@mantine/core';
import React from 'react';
import DataTable from 'react-data-table-component';
import ActionCell from './components/ActionCell';
import useGetMatchLimit from './useGetMatchLimit';
import LoadingErrorContainer from '../../components/placeholders/LoadingErrorContainer';

const Remote = () => {

    const { MatchLimitQuery: {
        data, isPending, isError, isRefetching },
    } = useGetMatchLimit()

    const columns = [
        {
            name: 'Type',
            selector: row => row.type,
            sortable: true,
        },
        {
            name: 'Premium(With Agency)',
            selector: row => row.slug != 'blurred-match' ? (row.slug != 'promote-match' ? row.premium + '/day' : row.premium + '/month') : row.premium ? 'Yes' : 'No',
            sortable: true,
        },
        // {
        //     name: 'Pro',
        //     selector: row => row.slug != 'blurred-match' ? (row.slug != 'promote-match' ? row.pro + '/day' : row.pro + '/month') : row.premium ? true : false,
        //     sortable: true,
        // },
        {
            name: 'Free(Without Agency)',
            selector: row => row.slug != 'blurred-match' ? (row.slug != 'promote-match' ? row.free + '/day' : row.free + '/month') : row.free ? 'Yes' : 'No',
            sortable: true,
        },

        {
            name: 'Action',
            cell: row => <ActionCell row={row} />,


        },
    ];





    return (
        <LoadingErrorContainer isError={isError} isLoading={isPending} isRefetching={isRefetching}>
            <Group justify='space-between'>
                <Title order={3}>Match Limitations</Title>

            </Group>
            <DataTable
                columns={columns}
                data={data ?? []}
                progressPending={isPending}




            // selectableRows

            />

        </LoadingErrorContainer>


    );

}

export default Remote;
